import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface DialogueStore {
  curBot: any;
  customerInfo: API.FeimaChatDialogueCustomerListResponse['data']['list'][0];
  totalMessageCount: number;
  setCurBot: (curBot: any) => void;
  setCustomerInfo: (
    info: API.FeimaChatDialogueCustomerListResponse['data']['list'][0]
  ) => void;
  setTotalMessageCount: (count: number) => void;
}

export const useDialogueStore = create<DialogueStore>()(
  persist(
    set => ({
      // 当前bot
      curBot: {},
      // 客户群信息/客户信息
      customerInfo:
        {} as API.FeimaChatDialogueCustomerListResponse['data']['list'][0],
      // 自定义消息总条数
      totalMessageCount: 0,

      setCurBot: (curBot: any) => {
        set({ curBot });
      },
      setCustomerInfo: (
        info: API.FeimaChatDialogueCustomerListResponse['data']['list'][0]
      ) => {
        set({ customerInfo: info });
      },
      setTotalMessageCount: (count: number) => {
        set({ totalMessageCount: count });
      },
    }),
    {
      name: 'customer-storage',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
